import React from 'react';
import HelpLink from 'components/pure/admin/HelpLink';
import ContextHelpText from './ContextHelpText';

export default class ArchivingProfilesPageHelp extends React.PureComponent {
  render() {
    const {department, hasDepartmentContext, archivingProfiles} = this.props;
    return (
      <HelpLink popoverClassName={'department-profile-help-text'}>
        <p>
          Archiving profiles allow you to define how long calls remain available to your users in
          the Coach360.
        </p>
        <p>
          Calls can be automatically removed after a preset number of days, exceptions can be
          granted for calls that are annotated, shared, or added to a library.
        </p>
        {hasDepartmentContext && department ? (
          <ContextHelpText
            department={department}
            profiles={archivingProfiles}
            profileName="Archiving"
          />
        ) : (
          <p>Click New Archiving Profile to configure a new profile.</p>
        )}
      </HelpLink>
    );
  }
}
